var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-tree"},_vm._l((_vm.value),function(item){return _c('TreeItem',{key:item.value,attrs:{"value":item,"root":true,"depth":1},on:{"on-change":_vm.onTreeItemChanged}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }